import { Customer } from "../../entities/Customer";
import { PartnerType } from "@/app/utils/partners.enum";
import { httpClient } from "../http/httpClient";

export interface Rg {
  number: string;
  uf: string;
  org: string;
  date: string;
}

export interface createCustomerBody {
  name: string;
  cpf: string;
  phone: string;
  email: string;
  maritalStatus?: string;
  renda?: number;
  rg?: Rg;
  birthDate?: string;
  address?: {
    zipCode: string;
    state: string;
    city: string;
    neighborhood: string;
    street: string;
    number: string;
    complement?: string;
  };
  bankAccount?: {
    bank: string;
    agency: string;
    account: string;
    accountType: string;
  };
}

export interface CustomerResponse extends Customer {}

export async function createCustomer(
  body: createCustomerBody,
  journey?: PartnerType,
) {
  const { data } = await httpClient
    .post<CustomerResponse>("/customer", body, { journey })
    .catch((err) => {
      throw err?.response?.data || err;
    });

  return data;
}
